import type { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';

type TInputExpirationDate = {
  error: spreedly.SpreedlyError['message'];
};

const getErrorTranslation = (error: string) => {
  // eslint-disable-next-line quotes
  if (error === "Month can't be blank") {
    return 'La fecha de expiración no puede estar en blanco.';
  }

  if (error === 'Year is invalid') {
    return 'El año de expiración no es válido.';
  }

  return error;
};

export const InputExpirationDate = ({ error }: TInputExpirationDate) => {
  const form = useFormContext<IFormFields>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D+/g, '');
    let formattedValue = '';

    if (value.length > 0) {
      formattedValue = value.slice(0, 2);
    }

    if (value.length > 2) {
      formattedValue += '/' + value.slice(2);
    }

    form.setValue('expiration_date', formattedValue);
  };

  return (
    <div className="co-flex co-w-full co-flex-col co-gap-[8px] co-h-fit">
      <LabelExpirationDate />
      <div className="co-flex co-flex-col co-gap-[4px] co-h-auto">
        <input
          type="text"
          id="expiration_date"
          placeholder="MM/AA"
          className="co-w-full co-h-[40px] co-border-[1px] co-border-[#B4C2CB] co-p-[12px] co-pl-16px co-bg-white co-rounded-[6px] co-box-border co-text-body1 co-leading-[20px] co-font-montserrat"
          maxLength={7}
          {...form.register('expiration_date', {
            onChange: (e) => handleChange(e),
            maxLength: {
              value: 5,
              message: 'La cantidad de caracteres ingresados es inválida'
            }
          })}
        />
        <InputError error={error} />
      </div>
    </div>
  );
};

const LabelExpirationDate = () => {
  return (
    <label
      className="co-flex co-w-fit co-text-[12px] co-font-semibold co-leading-[16px] co-text-[#363F45]"
      htmlFor="expirationDate"
    >
      Expiración
    </label>
  );
};

const InputError = ({
  error
}: {
  error: spreedly.SpreedlyError['message'];
}) => {
  if (!error) return <></>;

  const translatedError = getErrorTranslation(error);

  return (
    <p
      className="co-px-[8px] co-text-[12px] co-leading-[16px] co-font-medium co-text-[#E90200]"
      id="expiration_date"
    >
      {translatedError}
    </p>
  );
};
